import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import react, { useState } from "react";
import { setFormData } from "../../../../store/script/scriptSlice";
import { useDispatch } from "react-redux";
import { getLanguageAndVoiceFromVal } from "../../../../constants/scriptConfig";
import { useSelector } from "react-redux";
import { handleStepTwoSubmit } from "../../../../thunks/editor/scriptThunks";
import VoiceOptions from "./VoiceOptions";
import { Tooltip } from "../../Tooltip";

const slideOptions = Array(10).fill();

const GenerateScriptWithAI = () => {
  const dispatch = useDispatch();
  const { slides, currentSlideIndex } = useSelector((state) => state.slides);
  const { isOnlyAIVoice } = useSelector((state) => state.project);
  const { formData, chatGptData } = useSelector((state) => state.script);
  const { isAdmin } = useSelector((state) => state.user);
  const [stepIndex, setSTepIndex] = useState(1);
  const selectedVoice = getLanguageAndVoiceFromVal(
    slides[currentSlideIndex].voice
  );

  const isDidAvatar = slides[0]?.objects?.some((slide) => {
    // Check if the slide is an avatar and its URL includes "d-id"
    return slide.type === "avatar" && slide.url.includes("d-id");
  });

  return (
    <div className="flex flex-col gap-4 w-full h-full overflow-auto ">
      <div className="flex flex-row items-center justify-between">
        <div className="flex  gap-1 item-center flex-row justify-between">
          {stepIndex === 2 && (
            <div className="flex  gap-1 item-center flex-row ">
              <FontAwesomeIcon
                icon={faArrowLeft}
                onClick={() => setSTepIndex(1)}
                className="mr-2 p-1 h-4 border-gray-500 border rounded-lg cursor-pointer"
              />
              <span
                className="text-gray-500 cursor-pointer"
                onClick={() => setSTepIndex(1)}
              >
                {" "}
                BACK{" "}
              </span>
            </div>
          )}
          <span className="block mb-2 text-md font-semibold text-gray-700">
            Generated Script With AI
          </span>
          <span className="text-sm block text-gray-500">step{stepIndex}/2</span>
        </div>
      </div>

      {stepIndex === 1 && (
        <div className="flex flex-col gap-2 text-left">
          {!isOnlyAIVoice && (
            <div className="flex flex-row gap-2 items-center">
              <label>No of slides</label>
              <select
                name="totalSlide"
                defaultValue={formData?.totalSlide || "3"}
                value={isDidAvatar ? 1 : formData.totalSlide}
                disabled={isDidAvatar}
                onChange={(e) => {
                  // setLanguage(e.target.value);

                  dispatch(
                    setFormData({
                      ...formData,
                      totalSlide: e.target.value,
                    })
                  );
                }}
                className="w-1/2 p-2 border border-gray-300 text-xs rounded-lg"
              >
                {slideOptions.map((_, index) => (
                  <option key={`slide-option-${index}`} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </select>
            </div>
          )}
          <label
            htmlFor="scriptInput"
            className="block mb-2 text-sm font-semibold text-gray-700"
          >
            Write the topic for the video{" "}
          </label>
          <textarea
            name="videoTopic"
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Welcome to the new era of video creation with vidBoard! Simply type your script to get started!"
            rows="3"
            value={formData.videoTopic}
            onChange={(e) => {
              dispatch(
                setFormData({
                  ...formData,
                  videoTopic: e.target.value,
                })
              );
            }}
            style={{ height: "100px", resize: "none", overflowY: "auto" }}
          ></textarea>
          <label
            htmlFor="scriptInput"
            className="block mb-2 text-sm font-semibold text-gray-700"
          >
            who are the Audience of Your Video
          </label>
          <textarea
            name="targetAudience"
            value={formData.targetAudience}
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Welcome to the new era of video creation with vidBoard! Simply type your script to get started!"
            rows="3"
            onChange={(e) => {
              dispatch(
                setFormData({
                  ...formData,
                  targetAudience: e.target.value,
                })
              );
            }}
            style={{ height: "100px", resize: "none", overflowY: "auto" }}
          ></textarea>
          <div className="flex items-center gap-2 flex-row justify-end">
            <span>step{stepIndex}/2</span>
            <button
              onClick={() => stepIndex === 1 && setSTepIndex(2)}
              disabled={!(formData.videoTopic || "").trim()}
              className="group relative bg-black hover:bg-blue-600 text-white font-bold py-2 px-4 rounded inline-flex items-center"
            >
              Next
              {!(formData.videoTopic || "").trim() && (
                <Tooltip>Please add topic for the video</Tooltip>
              )}
            </button>
          </div>
        </div>
      )}
      {stepIndex === 2 && (
        <div className="flex flex-col gap-2 text-left">
          <span>Write the objective for your video script.</span>
          <textarea
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Welcome to the new era of video creation with vidBoard! Simply type your script to get started!"
            rows="3"
            name="videoObjective"
            value={formData.videoObjective}
            onChange={(e) => {
              dispatch(
                setFormData({
                  ...formData,
                  videoObjective: e.target.value,
                })
              );
            }}
            style={{ height: "100px", resize: "none", overflowY: "auto" }}
          ></textarea>
          <span>Describe the persona and tone of the script</span>
          <textarea
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Welcome to the new era of video creation with vidBoard! Simply type your script to get started!"
            rows="3"
            value={formData.videoTone}
            name="videoTone"
            onChange={(e) => {
              dispatch(
                setFormData({
                  ...formData,
                  videoTone: e.target.value,
                })
              );
            }}
            style={{ height: "100px", resize: "none", overflowY: "auto" }}
          ></textarea>
          {/* <div className=" w-full max-w-2xl mx-auto p-2 bg-vb-highlight rounded-lg border border-gray-400">
            <div className="">
              <div className="flex items-center m-2">
                <span
                  className={`fi fi${
                    selectedVoice?.languageData?.value
                      ?.slice(2)
                      ?.toLowerCase() || ""
                  }`}
                ></span>
                <span className="ml-3 block text-sm text-gray-700">
                  <span className="font-semibold text-base">
                    {selectedVoice.voiceData.name}
                  </span>
                  , {selectedVoice.voiceData.gender}
                </span>
              </div>
              <span className="ml-3 block text-sm text-gray-700">
                {selectedVoice.languageData.language}
              </span>
              <div className="flex items-center justify-between p-2 ">
                <button
                  className="inline-flex items-center px-4 py-2 border border-black text-sm font-medium rounded-md shadow-sm text-black bg-transparent hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                  onClick={() => setVoiceSelectorVisible(true)}
                >
                  Change Voice
                </button>
              </div>
            </div>
          </div> */}
          <div className="flex items-center gap-2 flex-row justify-end">
            <button
              onClick={() => setSTepIndex(1)}
              className="bg-black hover:bg-blue-600 text-white font-bold py-2 px-4 rounded inline-flex items-center"
            >
              BACK
            </button>
            <span>step{stepIndex}/2</span>
            <button
              onClick={() => {
                dispatch(handleStepTwoSubmit(formData));
              }}
              className="bg-black hover:bg-blue-600 text-white font-bold py-2 px-4 rounded inline-flex items-center"
            >
              Generate Script
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GenerateScriptWithAI;
